import angular from 'angular';

angular.module('cloudX').component('todoIcon', {
  template: `<span title="{{('ToDo'|translate)}}">
    <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 384 512"
    height="1em" width="1em" xmlns="http://www.w3.org/2000/svg" style="vertical-align: sub;"><path d="M298.028 214.267L285.793 96H328c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24H56C42.745 0 32 10.745 32 24v48c0 13.255 10.745 24 24 24h42.207L85.972 214.267C37.465 236.82 0 277.261 0 328c0 13.255 10.745 24 24 24h136v104.007c0 1.242.289 2.467.845 3.578l24 48c2.941 5.882 11.364 5.893 14.311 0l24-48a8.008 8.008 0 0 0 .845-3.578V352h136c13.255 0 24-10.745 24-24-.001-51.183-37.983-91.42-85.973-113.733z"></path></svg>
    </span>`,
});
